import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DefaultComponent } from './layouts/default/default.component';
import { DashboardComponent } from './modules/dashboard/dashboard.component';
import { AdmitagentComponent } from './modules/admitagent/admitagent.component';
import { PostsComponent } from './modules/posts/posts.component';
import { LoginComponent } from './login/login.component';
import { CustomersComponent } from './modules/customers/customers.component';
import { StickerlistingsComponent } from './modules/stickerlistings/stickerlistings.component';
import { RegisteredagentsComponent } from './modules/registeredagents/registeredagents.component';
import { AgtransactionsComponent } from './modules/agtransactions/agtransactions.component';
import { NewcustomerComponent } from './modules/newcustomer/newcustomer.component';
import { SendnotificationsComponent } from './modules/sendnotifications/sendnotifications.component';
import { ClaimsportalComponent } from './modules/claimsportal/claimsportal.component';
import { ManagerSetPasswordComponent } from './manager-set-password/manager-set-password.component';
import { ManagerExpiredLinkComponent } from './manager-expired-link/manager-expired-link.component';
import { ManagerPasswordsetSuccessComponent } from './manager-passwordset-success/manager-passwordset-success.component';
import { SignupmanagerComponent } from './modules/signupmanager/signupmanager.component';
import { ManagerstblComponent } from './modules/managerstbl/managerstbl.component';
import { ManagerResetpasswordComponent } from './modules/manager-resetpassword/manager-resetpassword.component';
import { ManagerResetpasswordSuccessComponent } from './modules/manager-resetpassword-success/manager-resetpassword-success.component';
import { ManagerResetpasswordExpiredlinkComponent } from './modules/manager-resetpassword-expiredlink/manager-resetpassword-expiredlink.component';
import { PolicylistingsComponent } from './modules/policylistings/policylistings.component';
import { MessagesComponent } from './modules/messages/messages.component';
import { RpaTestComponent} from './rpa-test/rpa-test.component';
import { brokersComponent } from './modules/brokers/brokers.component';
import { addBrokerComponent } from './modules/add-broker/add-broker.component';
import { ReportComponent } from './modules/report/report.component';
import { AddBrokerAdminComponent } from './modules/add-broker-admin/add-broker-admin.component';
import { BrokerAdminComponent } from './modules/broker-admin/broker-admin.component';
import { FleetMotorAddVehicleComponent } from './modules/fleet-motor-add-vehicle/fleet-motor-add-vehicle.component';
import { BillingComponent } from './modules/billing/billing.component';


const routes: Routes = [
  {path:'',component:LoginComponent},
  {path:'', component:DefaultComponent,
children:[
  {path:'dashboard', component: DashboardComponent},
  {path:'agentadmission', component: AdmitagentComponent},
  {path:'posts', component:PostsComponent},
  {path:'customers', component: CustomersComponent},
  {path:'stickerlistings', component: StickerlistingsComponent},
  {path:'registeredagents', component:RegisteredagentsComponent},
  {path:'transactions', component:AgtransactionsComponent},
  {path:'newcustomer', component:NewcustomerComponent},
  {path:'notifications', component:SendnotificationsComponent},
  {path:'claimsportal', component:ClaimsportalComponent},
  {path:'signupmanager', component: SignupmanagerComponent},
  {path:'allmanagers', component: ManagerstblComponent},
  {path:'stickerlistings', component: StickerlistingsComponent},
  {path:'policylistings', component:PolicylistingsComponent},
  {path:'messages', component:MessagesComponent},
  {path:'brokers', component:brokersComponent},
  {path:'add-broker', component:addBrokerComponent},
  {path:'report', component:ReportComponent},
  {path:'add-broker-admin', component:AddBrokerAdminComponent},
  {path:'broker-admin', component:BrokerAdminComponent},
  {path:'fleet-motor-add-vehicle', component:FleetMotorAddVehicleComponent},
  {path:'billing', component:BillingComponent}

  
]
},
//setting manager password
{path: 'confirm_manager_password', component: ManagerSetPasswordComponent},
{path:'confirm_manager_password/:email/:token', component: ManagerSetPasswordComponent},
{path:'manager_expired_link', component: ManagerExpiredLinkComponent},  
{path:'manager_password_success', component:ManagerPasswordsetSuccessComponent} ,
//end of setting manager password

// reset forgot password by manager
{path: 'reset_manager_password', component:ManagerResetpasswordComponent},
{path:'reset_manager_password/:email/:token', component: ManagerResetpasswordComponent},
{path:'reset_manager_expired_link', component: ManagerResetpasswordExpiredlinkComponent},  
{path:'reset_manager_password_success', component:ManagerResetpasswordSuccessComponent} ,
{path:'rpa', component:RpaTestComponent} 



];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
